"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlUIScreenStatusSerialization = void 0;
const ChargerUIScreenStatusSerialization_1 = require("./ChargerUIScreenStatusSerialization");
class ChargerControlUIScreenStatusSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.ports = entity.ports?.map((field) => field
            ? JSON.parse(ChargerUIScreenStatusSerialization_1.ChargerUIScreenStatusSerialization.serialize(field))
            : undefined);
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.ports = entity.ports?.map((field) => field
            ? ChargerUIScreenStatusSerialization_1.ChargerUIScreenStatusSerialization.deserialize(JSON.stringify(field))
            : undefined);
        return copy;
    }
}
exports.ChargerControlUIScreenStatusSerialization = ChargerControlUIScreenStatusSerialization;
